import { FC } from 'react';
import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import LeaderboardPage from '../../../pages/Cards/LeaderboardPage';
import LeaderboardMobile from '../../../pages/Mobile/Cards/LeaderboardMobile';

const LeaderboardResponsive: FC = () => {
  const { isMobile } = useResponsiveRedux();
  return isMobile ? <LeaderboardMobile /> : <LeaderboardPage />;
};

export default LeaderboardResponsive;
